import React from 'react';
import RichTextCta from '../components/RichTextCta';
import RichTextBlockQuote from '../components/RichTextBlockQuote';
import RichTextConversionPanel from '../components/RichTextConversionPanel';
import RichTextInlineMarketingForm from '../components/RichTextInlineMarketingForm';
import RichTextEmbed from '../components/RichTextEmbed';
import RichTextImageMp4 from '../components/RichTextImageMp4';
import RichTextVideo from '../components/RichTextVideo';
import RichTextTable from '../components/RichTextTable';
import RichTextAd from '../components/RichTextAd';

const optionsEmbeds = (node, alignDesktop, alignMobile, dataPosition, formType) => {
  const type = node?.data?.target?.sys?.contentType?.sys?.id;
  const component = node?.data?.target;

  if (type === 'inlineMarketingForm') {
    return (
      <RichTextInlineMarketingForm {...component} dataPosition={dataPosition} formType={formType} />
    );
  } else if (type === 'callToAction') {
    return (
      <RichTextCta
        {...component}
        alignDesktop={alignDesktop}
        alignMobile={alignMobile}
        dataPosition={dataPosition}
        formType={formType}
      />
    );
  } else if (type === 'blockQuote') {
    return <RichTextBlockQuote {...component} />;
  } else if (type === 'conversionPanel') {
    return (
      <RichTextConversionPanel {...component} dataPosition={dataPosition} formType={formType} />
    );
  } else if (type === 'wistiaVideo') {
    return <RichTextVideo {...component} />;
  } else if (type === 'embed') {
    return <RichTextEmbed {...component} />;
  } else if (type === 'image') {
    return (
      <RichTextImageMp4 alignDesktop={alignDesktop} alignMobile={alignMobile} {...component} />
    );
  } else if (type === 'table') {
    return <RichTextTable {...component} />;
  } else if (type === 'ad') {
    return <RichTextAd {...component} />;
  }
};

export default optionsEmbeds;
